/* ============================================================
   Long Run Co. - Daily System landing page.
   Phase 1: header scroll-state + the [data-scroll] jump contract.

   EVERY DOM lookup in this file goes through $ / $$ / byId, and all
   three are scoped to ROOT. There is deliberately no bare
   document.querySelector anywhere: the LP2 build shipped 19 unscoped
   lookups that had to be chased down later, and this file exists to
   not repeat that. If you add code here, use the helpers.
   ============================================================ */
(function () {
  'use strict';

  var ROOT = document.querySelector('.lrc-ds-root');
  if (!ROOT) return;

  /* ---------- ROOT-scoped helpers ---------- */
  var $ = function (s, r) { return (r || ROOT).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || ROOT).querySelectorAll(s)); };
  var byId = function (id, r) {
    if (!id) return null;
    return (r || ROOT).querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id));
  };
  var reduced = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  /* ---------- header scroll state ----------
     Mechanism copied from assets/lrc-lp2.js lines 482-503: the rAF
     `ticking` throttle, the { passive: true } scroll listener, the
     manual scrollRestoration, and re-evaluation on all four load
     paths so a reload-while-scrolled or a bfcache restore cannot
     start in the wrong state.
     Two deliberate differences from LP2:
       - the element is found ROOT-scoped, not document-scoped;
       - the state is written as data-scrolled="true|false" rather
         than a class, because the mockup's CSS keys off the
         attribute selector .ds-hdr[data-scrolled="true"].
     The threshold is a theme setting, published by the header
     section as data-scroll-threshold. */
  (function () {
    var header = $('[data-ds-header]');
    if (!header) return;

    var threshold = parseInt(header.getAttribute('data-scroll-threshold'), 10);
    if (isNaN(threshold) || threshold < 0) threshold = 420;

    if ('scrollRestoration' in history) {
      try { history.scrollRestoration = 'manual'; } catch (e) {}
    }

    var ticking = false;
    function evalState() {
      var y = window.pageYOffset || window.scrollY || 0;
      header.setAttribute('data-scrolled', String(y > threshold));
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(evalState); }
    }, { passive: true });
    window.addEventListener('DOMContentLoaded', evalState);
    window.addEventListener('load', evalState);
    window.addEventListener('pageshow', evalState);
    evalState();
  })();

  /* ---------- [data-scroll] jump contract ----------
     Copied from the mockup's scroll contract, with the listener bound
     to ROOT instead of document and the target resolved inside ROOT.
     Phase 1 ships no jump targets yet, so this is a no-op until the
     offer section lands. */
  ROOT.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-scroll]');
    if (!t) return;
    var el = byId(t.getAttribute('data-scroll'));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- day graph: tabs drive panel + chart marker ----------
     Copied from the mockup's day-tab handler (lines 1485-1497), with three
     changes: the listener is delegated from ROOT instead of bound per tab,
     every lookup is ROOT-scoped rather than document-scoped, and the keys are
     Shopify block ids rather than the mockup's hardcoded am/mid/pm.

     All THREE states are switched together - aria-selected on the tab,
     data-on on the panel, and .on on the dot group, its circle and its tick.
     Drop any one of them and the chart marker desyncs from the visible panel. */
  ROOT.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ds-day]');
    if (!tab || !ROOT.contains(tab)) return;
    var key = tab.getAttribute('data-ds-day');

    $$('[data-ds-day]').forEach(function (x) {
      x.setAttribute('aria-selected', String(x === tab));
    });
    $$('[data-ds-panel]').forEach(function (p) {
      p.setAttribute('data-on', String(p.getAttribute('data-ds-panel') === key));
    });
    /* PHASE 3 FIX. The mockup declares `.dc-dot { transition: r .22s }` but no
       rule or handler ever changed r, so the 6am marker kept the larger radius
       baked into its markup no matter which tab was selected. The radius now
       follows the selection: the active dot gets dotRActive, every other dot
       gets dotR. Both are settings on the offer section. */
    var cfg = window.LRC_DS_OFFER || {};
    var rOn = cfg.dotRActive, rOff = cfg.dotR;
    $$('[data-ds-dot]').forEach(function (g) {
      var on = g.getAttribute('data-ds-dot') === key;
      g.classList.toggle('on', on);
      var dot = $('.ds-dc-dot', g);
      var tick = $('.ds-dc-tick', g);
      if (dot) {
        dot.classList.toggle('on', on);
        var r = on ? rOn : rOff;
        if (r != null && r !== '') dot.setAttribute('r', r);
      }
      if (tick) tick.classList.toggle('on', on);
    });
  });

  /* ---------- reveal-on-scroll for .ds-rv ----------
     The class MUST be 'ds-in': assets/lrc-ds.css:63 is `.lrc-ds-root .ds-rv.ds-in`.
     The mockup uses a bare 'in'; the ds- rename moved the CSS and left the JS behind,
     which pinned ten sections at opacity 0.
     Copied from the mockup's IntersectionObserver block (lines 1568-1578),
     ROOT-scoped. Reduced motion and no-IO browsers get the end state at once. */
  (function () {
    var items = $$('.ds-rv');
    if (!items.length) return;
    if (reduced() || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('ds-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x, i) {
        if (!x.isIntersecting) return;
        setTimeout(function () { x.target.classList.add('ds-in'); }, i * 45);
        io.unobserve(x.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  })();

  /* ══════════════════════════════════════════════════════════════════════
     THE OFFER. All offer state lives here. Prices arrive already resolved
     from Shopify in the section's JSON config; nothing is typed in JS.
     ══════════════════════════════════════════════════════════════════════ */
  (function () {
    var SEC = $('[data-ds-offer]');
    if (!SEC) return;
    var raw = $('[data-ds-offer-config]', SEC);
    if (!raw) return;
    var CFG;
    /* Fail safe, but NEVER fail silently. A malformed payload used to return here with
       no console output at all, which cost three rounds of diagnosis to find: a Liquid
       error raised inside the JSON (an unguarded image_url on an unset image) landed
       unquoted in the payload, JSON.parse threw, and the whole offer module aborted
       leaving only its static chrome on the page. Log the error AND the offending text
       so the next one is a five-second read of the console. */
    try {
      CFG = JSON.parse(raw.textContent);
    } catch (e) {
      console.error('[lrc-ds] offer config failed to parse — the offer section will not render.', e);
      console.error('[lrc-ds] offending payload:', raw.textContent);
      return;
    }
    window.LRC_DS_OFFER = CFG;

    var state = { tier: (CFG.tiers[0] || {}).id, plan: 'sub', gift: (CFG.gifts[0] || {}).id };

    /* Shopify prices are integer cents everywhere. Convert once, at the edge. */
    var money = function (n) { return '$' + (n / 100).toFixed(2); };
    var tierOf = function (id) {
      for (var i = 0; i < CFG.tiers.length; i++) if (CFG.tiers[i].id === id) return CFG.tiers[i];
      return CFG.tiers[0];
    };
    var giftOf = function (id) {
      for (var i = 0; i < CFG.gifts.length; i++) if (CFG.gifts[i].id === id) return CFG.gifts[i];
      return CFG.gifts[0];
    };

    /* ---------- the money ----------
       pay   = every line at the selected plan's price
       list  = every line at its one-time price
       gift  = the selected gift's retail value
       hat   = the hat's retail value, only where the tier grants it
       ship  = the shipping value, only where the tier grants free shipping
       worth = list + gift + hat + ship          <- the struck compare-at
       save  = worth - pay
       Counting the gift, hat and shipping into compare-at is the whole point:
       they are things the shopper would otherwise pay for. */
    function math(t) {
      var pay = 0, list = 0, bags = 0, tins = 0;
      (t.lines || []).forEach(function (l) {
        var unit = state.plan === 'sub' ? l.plan : l.once;
        pay += unit * l.qty;
        list += l.once * l.qty;
        if (l.kind === 'coffee') bags += l.qty; else tins += l.qty;
      });
      var g = giftOf(state.gift) || { value: 0 };
      var gift = g.value || 0;
      var hat = t.hat ? (CFG.hatValue || 0) : 0;
      var ship = t.freeShip ? (CFG.shippingValue || 0) : 0;   /* already cents */
      var worth = list + gift + hat + ship;
      var servings = bags * CFG.coffeeServings + tins * CFG.pouchServings;
      return { pay: pay, list: list, gift: gift, hat: hat, ship: ship,
               worth: worth, save: worth - pay, bags: bags, tins: tins, servings: servings };
    }

    /* Per-unit figures are per PRODUCT, never blended. A cup and a pouch are
       different units; one blended figure moves with the box's mix and can read
       higher on a bigger box. Both are taken from the first line of each kind,
       which is the unit price the shopper actually pays. */
    function unitOf(t, kind) {
      var lines = (t.lines || []).filter(function (l) { return l.kind === kind; });
      if (!lines.length) return null;
      var l = lines[0];
      var per = state.plan === 'sub' ? l.plan : l.once;
      var servings = kind === 'coffee' ? CFG.coffeeServings : CFG.pouchServings;
      return servings > 0 ? per / servings : null;
    }

    /* ---------- odometer ----------
       Copied from the mockup's countTo (lines 1363-1372) verbatim: the same
       reduced-motion bail, the same <0.005 no-op guard, the same cubic
       ease-out 1-(1-k)^3, the same rAF loop. Only the duration is a setting. */
    function countTo(el, to, fmt) {
      if (!el) return;
      var from = parseFloat((el.textContent || '').replace(/[^0-9.]/g, '')) || 0;
      from = from * 100;
      if (reduced() || Math.abs(to - from) < 0.5) { el.textContent = fmt(to); return; }
      var t0 = performance.now(), dur = CFG.odometerMs;
      (function step(now) {
        var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        el.textContent = fmt(from + (to - from) * e);
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    }

    /* ---------- tiers ---------- */
    function icon(id, sw) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' +
             (sw || 2.2) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><use href="#' + id + '"/></svg>';
    }
    var esc = function (t) {
      return String(t == null ? '' : t)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    };

    /* Tier tile. Mirrors renderTiers() in _reference/daily-system-mockup.html:
       a SUMMARY of three to five rows, never the per-line enumeration - the
       per-line detail belongs only in the What's inside sheet. Row wording is
       editable via CFG.labels.row*; the mockup's literals are the defaults. */
    function fill(tpl, map) {
      return String(tpl == null ? '' : tpl).replace(/\{(\w+)\}/g, function (_, k) {
        return map[k] == null ? '' : String(map[k]);
      });
    }
    /* One definition of the tile's savings percentage. renderTiers() and refreshTierMeta()
       both call it, so the initial paint and every later repaint cannot disagree. */
    function pctOf(m) { return m.worth > 0 ? Math.round((m.worth - m.pay) / m.worth * 100) : 0; }

    function renderTiers() {
      var host = $('[data-ds-tiers]', SEC);
      if (!host) return;
      var L = CFG.labels || {};
      host.innerHTML = CFG.tiers.map(function (t) {
        var m = math(t);
        var g = giftOf(state.gift);
        /* Every row carries the SAME check icon at the mockup's 2.6 stroke.
           Only the colour differs, and that comes from .ds-is-free in CSS. */
        var row = function (txt, free, attr) {
          return '<li' + (free ? ' class="ds-is-free"' : '') + (attr ? ' ' + attr : '') + '>' + icon('i-check', 2.6) +
                 '<span>' + txt + '</span></li>';
        };
        var rows = '';
        if (m.bags) rows += row(esc(fill(L.rowCoffee, { n: m.bags, s: m.bags > 1 ? 's' : '' })));
        if (m.tins) {
          /* the mockup dims the parenthetical with .mut; keep the bracket inside it */
          var pt = esc(fill(L.rowPouch, { n: m.tins, servings: m.tins * CFG.pouchServings }));
          pt = pt.replace(/(\([^)]*\))/, '<span class="ds-mut">$1</span>');
          rows += row(pt);
        }
        if (g) rows += row(esc(fill(L.rowGift, { gift: g.label })), true, 'data-ds-row-gift');
        if (t.hat) rows += row(esc(L.rowHat), true);
        if (t.freeShip) rows += row(esc(L.rowShip));      /* deliberately NOT amber */

        var warn = '';
        if (SEC.getAttribute('data-design-mode') === 'true') {
          var w = [];
          if (t.badRows) w.push(t.badRows + ' malformed line(s) skipped');
          if (t.noVariant) w.push('no variant id: ' + esc(t.noVariant));
          if (t.notFound) w.push('not in the catalog collection: ' + esc(t.notFound));
          if (w.length) warn = '<div class="ds-warn">' + esc(t.name) + ' - ' + w.join('. ') + '.</div>';
        }
        /* COMPARE-AT ON THE TILE IS m.worth, NOT m.list.
           m.list is the products at one-time price, which on the ONE TIME plan is exactly
           what the shopper pays - the tile struck through a number identical to its own
           price. worth adds everything they receive free (the SELECTED gift, the hat where
           the tier grants it, shipping where it is covered), so the strike-through means
           "what this would cost you elsewhere" in both plan states.
           The summary block above Add to cart already used worth and is untouched. */
        var was = m.pay < m.worth
          ? '<s class="ds-was ds-num" data-ds-was="' + esc(t.id) + '">' + money(m.worth) + '</s>'
          : '<s class="ds-was" data-ds-was="' + esc(t.id) + '">&nbsp;</s>';
        /* Savings pill off the SAME figure, so strike-through, price and pill agree, and in
           BOTH plan states - a one-time buyer still saves the gift, hat and shipping. */
        var save = '<span class="ds-tier-save" data-ds-save="' + esc(t.id) + '">' +
                   esc(fill(L.saveTemplate, { pct: pctOf(m) })) + '</span>';

        return '<div class="ds-tier' + (t.popular ? ' ds-has-pop' : '') + '" role="button" tabindex="0"' +
               ' data-ds-tier="' + esc(t.id) + '" data-active="' + (t.id === state.tier) + '">' +
               (t.popular ? '<span class="ds-tier-pop">' + esc(L.pop) + '</span>' : '') +
               '<div class="ds-tier-top"><span class="ds-tier-radio"></span>' +
               '<span class="ds-tier-id"><b>' + esc(t.name) + '</b><span>' + esc(t.note) + '</span></span>' +
               '<span class="ds-tier-price"><span class="ds-now ds-num" data-ds-price="' + esc(t.id) + '">' + money(m.pay) + '</span>' +
               was + '</span></div>' +
               '<ul class="ds-tier-inc">' + rows + '</ul>' +
               '<div class="ds-tier-foot">' + save +
               /* label first, arrow on the RIGHT, as in the mockup */
               '<span role="button" tabindex="0" data-ds-inside="' + esc(t.id) + '">What\'s inside ' + icon('i-up', 2.4) + '</span>' +
               '</div>' + warn + '</div>';
      }).join('');
    }

    /* The tile's compare-at, savings pill and gift row all depend on the SELECTED GIFT and
       the plan, but renderTiers() runs once at init. Before this, swapping the gift left the
       tile still naming the old gift and still striking the old total - the tiles were the
       one part of the page that never heard about the swap.
       This updates those three nodes in place rather than re-rendering, so the price odometer
       in rollTierPrices() still animates from its previous value on a plan change. */
    function refreshTierMeta() {
      var L = CFG.labels || {}, g = giftOf(state.gift);
      CFG.tiers.forEach(function (t) {
        var m = math(t);
        var was = $('[data-ds-was="' + t.id + '"]', SEC);
        if (was) {
          if (m.pay < m.worth) { was.className = 'ds-was ds-num'; was.textContent = money(m.worth); }
          else { was.className = 'ds-was'; was.innerHTML = '&nbsp;'; }
        }
        var sv = $('[data-ds-save="' + t.id + '"]', SEC);
        if (sv) sv.textContent = fill(L.saveTemplate, { pct: pctOf(m) });
        var gr = $('[data-ds-tier="' + t.id + '"] [data-ds-row-gift] span', SEC);
        if (gr && g) gr.textContent = fill(L.rowGift, { gift: g.label });
      });
    }

    function paintActive() {
      $$('[data-ds-tier]', SEC).forEach(function (el) {
        el.setAttribute('data-active', String(el.getAttribute('data-ds-tier') === state.tier));
      });
    }
    function rollTierPrices() {
      CFG.tiers.forEach(function (t) {
        var m = math(t);
        countTo($('[data-ds-price="' + t.id + '"]', SEC), m.pay, money);
      });
    }

    /* ---------- gift ---------- */
    function renderGiftSwitch() {
      var sw = $('[data-ds-gift-sw]', SEC);
      if (!sw) return;
      sw.innerHTML = CFG.gifts.map(function (g) {
        return '<button type="button" data-ds-gift="' + esc(g.id) + '" aria-pressed="' +
               (g.id === state.gift) + '">' + esc(g.label) + '</button>';
      }).join('');
    }
    function renderGift() {
      var g = giftOf(state.gift);
      if (!g) return;
      var pic = $('[data-ds-gift-pic]', SEC);
      if (pic) {
        pic.innerHTML = g.img
          ? '<img src="' + esc(g.img) + '" alt="' + esc(g.label) + '" width="200" height="200" loading="lazy">'
          : esc(g.placeholder);
        /* The chip itself (paper fill, rounded box) is deliberate framing for a small
           product thumbnail. The DASHED border is not - dashed is empty-state chrome, and
           it ringed a real photo. ds-has-img swaps it to a solid hairline. */
        pic.classList.toggle('ds-has-img', !!g.img);
      }
      var n = $('[data-ds-gift-name]', SEC); if (n) n.textContent = g.label;
      var d = $('[data-ds-gift-desc]', SEC); if (d) d.textContent = g.desc;
      var w = $('[data-ds-gift-was]', SEC); if (w) w.textContent = money(g.value);
      var y = $('[data-ds-gift-why]', SEC); if (y) y.textContent = g.why;
      $$('[data-ds-gift]', SEC).forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-ds-gift') === state.gift));
      });
    }

    /* ---------- shipping + summary ---------- */
    function renderCheckout() {
      var t = tierOf(state.tier), m = math(t);
      var at = CFG.freeShipAt || 0;   /* already cents */
      var pct = at > 0 ? Math.min(100, m.pay / at * 100) : 100;
      var gap = at - m.pay;
      var fill = $('[data-ds-ship-fill]', SEC); if (fill) fill.style.width = pct + '%';
      var now = $('[data-ds-ship-now]', SEC); if (now) now.textContent = money(m.pay);
      var msg = $('[data-ds-ship-msg]', SEC);
      if (msg) {
        msg.innerHTML = gap > 0
          ? esc(CFG.labels.shipGap).replace('{gap}', '<b>' + money(gap) + '</b>')
          : '<b>' + esc(CFG.labels.shipDone) + '</b>';
      }
      var nm = $('[data-ds-sum-name]', SEC); if (nm) nm.textContent = t.name;
      countTo($('[data-ds-sum-was]', SEC), m.worth, money);
      countTo($('[data-ds-sum-total]', SEC), m.pay, money);
      var pc = unitOf(t, 'coffee'), pp = unitOf(t, 'pouch');
      if (pc != null) countTo($('[data-ds-per-cup]', SEC), pc, money);
      if (pp != null) countTo($('[data-ds-per-pouch]', SEC), pp, money);
      var sv = $('[data-ds-sum-save]', SEC); if (sv) sv.textContent = CFG.labels.save + ' ' + money(m.save);
      var cw = $('[data-ds-cta-was]', SEC); if (cw) cw.textContent = money(m.worth);
      var cp = $('[data-ds-cta-price]', SEC); if (cp) cp.textContent = money(m.pay);
      var st = $('[data-ds-st-total]', SEC); if (st) st.textContent = money(m.pay);
      var sn = $('[data-ds-st-name]', SEC); if (sn) sn.textContent = t.name;
    }
    function update() { renderGift(); renderCheckout(); }

    /* ---------- what's inside sheet ----------
       Open state is data-show, never data-open. That began as a collision guard - a scrim
       carrying data-open would have matched closest('[data-open]') and fired the bundle
       builder's page-wide trigger on every backdrop click. That trigger lives in
       assets/lrc-bb.js, which this page does not load, and the last [data-open] element
       here (the build-your-own link) is now a plain <a href>. So the collision is gone and
       data-show is simply the convention this file uses. Keep it. */
    function openInside(id) {
      var t = tierOf(id), m = math(t), g = giftOf(state.gift);
      var nm = $('[data-ds-ins-name]', SEC); if (nm) nm.textContent = t.name;
      var ct = $('[data-ds-ins-count]', SEC);
      if (ct) {
        ct.textContent = String(CFG.labels.insideCount)
          .replace('{bags}', m.bags).replace('{tins}', m.tins).replace('{servings}', m.servings);
      }
      var body = $('[data-ds-ins-body]', SEC);
      if (body) {
        /* product tiles grouped by category only. No freeform prose. */
        var groups = [
          { key: 'coffee', title: 'Coffee' },
          { key: 'pouch', title: 'Pouches' }
        ];
        var html = groups.map(function (grp) {
          var items = (t.lines || []).filter(function (l) { return l.kind === grp.key; });
          if (!items.length) return '';
          return '<div class="ds-ins-grp"><h4>' + grp.title + '</h4>' + items.map(function (l) {
            return '<div class="ds-ins-item">' +
              '<span class="ds-ins-pic' + (l.img ? ' ds-has-img' : '') + '">' + (l.img
                ? '<img src="' + esc(l.img) + '" alt="' + esc(l.label) + '" width="200" height="200" loading="lazy">'
                : '') + '</span>' +
              '<span class="ds-tx"><b>' + esc(l.label) + '</b><span>' + esc(l.note) + '</span></span>' +
              '<span class="ds-ins-qty">x' + l.qty + '</span></div>';
          }).join('') + '</div>';
        }).join('');
        /* Included free, matching the mockup's openInside(): the gift always, the hat when
           the tier grants one, shipping when it is covered. The hat image comes from the
           catalog index (CFG.hatImg); shipping has no product photo, so its box stays the
           dashed placeholder rather than rendering a broken <img>. */
        var pic = function (src, alt) {
          return '<span class="ds-ins-pic' + (src ? ' ds-has-img' : '') + '">' + (src
            ? '<img src="' + esc(src) + '" alt="' + esc(alt) + '" width="200" height="200" loading="lazy">'
            : '') + '</span>';
        };
        var freeRows = '';
        if (g) freeRows += '<div class="ds-ins-item ds-is-free">' + pic(g.img, g.label) +
          '<span class="ds-tx"><b>' + esc(g.label) + '</b><span>' + esc(g.desc) + '</span></span>' +
          '<span class="ds-ins-qty">' + esc(CFG.labels.free) + '</span></div>';
        if (t.hat) freeRows += '<div class="ds-ins-item ds-is-free">' + pic(CFG.hatImg, 'Long Run trail hat') +
          '<span class="ds-tx"><b>Long Run trail hat</b><span>One size, adjustable</span></span>' +
          '<span class="ds-ins-qty">' + esc(CFG.labels.free) + '</span></div>';
        /* Shipping has no product photo. Rather than an empty dashed box, put the i-truck
           sprite in it — same amber as the other free rows, which it inherits from
           .ds-ins-item.ds-is-free .ds-ins-pic svg in lrc-ds.css. Sprite <use>, not an
           image file and not an emoji. */
        if (t.freeShip) freeRows += '<div class="ds-ins-item ds-is-free">' +
          '<span class="ds-ins-pic ds-ins-pic-icon">' + icon('i-truck', 1.9) + '</span>' +
          '<span class="ds-tx"><b>Shipping</b><span>Ships in one business day</span></span>' +
          '<span class="ds-ins-qty">' + esc(CFG.labels.free) + '</span></div>';
        if (freeRows) html += '<div class="ds-ins-grp"><h4>' + esc(CFG.labels.free) + '</h4>' + freeRows + '</div>';
        body.innerHTML = html;
      }
      var sheet = $('[data-ds-sheet]', SEC);
      if (sheet) sheet.setAttribute('data-show', 'true');
    }
    function closeSheet() {
      var sheet = $('[data-ds-sheet]', SEC);
      if (sheet) sheet.setAttribute('data-show', 'false');
    }

    /* ---------- ADD TO CART - LIVE ----------
       Signature: addToCart() -> undefined
       The sequence, adapted from assets/lrc-bb.js checkout():
         1. POST /cart/clear.js
         2. POST /cart/add.js with { items: cartItems() } - tier lines carrying
            selling_plan when state.plan === 'sub', then the gift and the hat as
            one-time lines that never carry one.
         3. window.location.href = checkoutUrl(), i.e.
            /checkout?discount=<the tier+gift combination's code>
       ALL SIX buttons run this one function: the main CTA, the sticky CTA and the
       four express buttons. There is no second checkout path anywhere in this file. */
    /* ---------- checkout ----------------------------------------------------
       Sequence lifted from assets/lrc-bb.js checkout() (the bundle builder), which
       is in production and takes real orders: clear -> add -> navigate, each step
       gated on the previous one's response, never a blind navigate.

       WHAT IS DIFFERENT HERE, deliberately:
         - lrc-bb applies N codes with sequential GET /discount/<code> calls because a
           box can win several gifts. This page has exactly one code per tier+gift
           combination, so the single ?discount= form is enough and there is nothing
           to accumulate.
         - lrc-bb sends its gifts as $0 line items, and SO DOES THIS PAGE. See
           cartItems() below: a Buy X Get Y discount does not add anything to a cart,
           it discounts what is already in it. Shipping is the one thing the code
           gives outright, because shipping is not a line item.                       */

    /* Tier lines, then the gift, then the hat.

       WHY THE GIFT AND THE HAT ARE LINE ITEMS.
       A Shopify Buy X Get Y discount NEVER adds a product to the cart. It finds
       matching lines already present and takes them to $0. With the gift absent the
       code has nothing to apply to, the cart is short, and the shopper is promised a
       free tea they never receive. An earlier revision of this function posted tier
       lines only, on the reasoning that "the discount code gives them" - that
       reasoning was wrong and this is the correction. The proven builder,
       assets/lrc-bb.js checkoutItems() lines 626-632, does the same thing: it pushes
       every won gift as its own line and lets the BXGY zero it. The one difference is
       quantity - lrc-bb hardcodes quantity 1 because a bundle gift is always a single
       unit; this page reads value_qty, because the CAFFYNE gift is two tins.

       NO selling_plan ON THE GIFT OR THE HAT. Both are ONE-TIME lines, even when the
       tier is subscribed. Attaching the box's selling plan would enrol a free tea and
       a free hat in a recurring subscription and bill for them from cycle two onward.
       lrc-bb.js line 630 draws the same line: its 'always' and 'choose' gifts carry no
       plan and are zeroed outright by the BXGY; only its 'recurring' gift type - which
       has no equivalent on this page, every gift here is one-time - joins the plan,
       and it carries its own recurringCycleLimit-1 code to pay for that.

       QUANTITY comes from the gift block's value_qty (Liquid publishes it as g.qty,
       already defaulted and floored to 1): the tea is 1, the CAFFYNE gift is 2 tins.

       SHIPPING IS NEVER A LINE ITEM. Free shipping is a shipping-rate discount, not a
       product, so t.freeShip contributes to the compare-at maths in math() and to the
       What's inside sheet, and to nothing here. */
    /* The tier's own product lines, alone. Split out from cartItems() because the
       empty-box guard in addToCart() has to ask "does this box contain any PRODUCT?"
       and cartItems() can no longer answer that: now the gift and the hat are always
       appended, a tier whose every line is unusable would still return a non-empty
       array, the guard would never fire, and the shopper would be sent to checkout
       holding nothing but a free tea. */
    function tierItems() {
      var t = tierOf(state.tier), items = [];
      var plan = (state.plan === 'sub' && CFG.planId) ? CFG.planId : 0;
      (t.lines || []).forEach(function (l) {
        var id = parseInt(l.id, 10);
        if (!id || l.qty <= 0) return;
        var line = { id: id, quantity: l.qty };
        if (plan) line.selling_plan = plan;
        items.push(line);
      });
      return items;
    }
    function cartItems() {
      var t = tierOf(state.tier), items = tierItems();
      /* The selected gift, at its own quantity. One-time: no selling_plan, ever. */
      var g = giftOf(state.gift);
      var gid = g ? parseInt(g.variant, 10) : 0;
      var gqty = g ? (parseInt(g.qty, 10) || 1) : 0;
      if (gid && gqty > 0) items.push({ id: gid, quantity: gqty });
      /* The hat, quantity 1, ONLY where the tier grants it. One-time: no selling_plan. */
      var hid = parseInt(CFG.hatVariant, 10);
      if (t.hat && hid) items.push({ id: hid, quantity: 1 });
      return items;
    }

    /* Any tier line the Liquid index could not price or found unavailable. Sending a
       cart containing one produces a 422 from Shopify or, worse, a silently short cart. */
    function unavailable() {
      var t = tierOf(state.tier);
      return (t.lines || []).filter(function (l) { return !l.ok; });
    }

    /* Four combinations, four codes: (tea | pouches) x (hat | no hat). The hat is a
       property of the TIER, but the code is named for what it gives away, so both codes
       live on the GIFT block - two fields beside the gift they belong to, rather than a
       code-per-gift grid on every tier block. Two gifts x two fields = 4 settings; the
       per-tier alternative would have been 3 tiers x 2 gifts = 6, five of which would
       repeat. Blank is a valid, expected value: it simply omits the discount step. */
    function discountCode() {
      var g = giftOf(state.gift), t = tierOf(state.tier);
      if (!g || !t) return '';
      var code = t.hat ? g.codeHat : g.code;
      return String(code == null ? '' : code).trim();
    }
    function checkoutUrl() {
      var code = discountCode();
      return code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
    }

    var submitting = false;
    function ctaMsg(text) {
      var el = $('[data-ds-cta-msg]', SEC);
      if (!el) return;
      if (!text) { el.hidden = true; el.textContent = ''; return; }
      el.textContent = text;
      el.hidden = false;
    }
    /* Every button that can start a checkout, in one list. The pending state and the
       disable/restore in addToCart() both drive off this, so adding a button to the
       selector is the ONLY thing needed to bring it under the guard. Six today: the
       main CTA, the sticky CTA, and the four express buttons. */
    function ctaButtons() {
      return $$('[data-ds-cta],[data-ds-st-cta],[data-ds-x-cta]', SEC);
    }
    function addToCart(pressed) {
      if (submitting) return;                       /* double-tap guard */

      /* Emptiness is a question about the BOX, not about the cart: the gift and the
         hat are appended unconditionally, so cartItems().length is never 0 here. */
      var items = cartItems();
      if (!tierItems().length) { ctaMsg('This box has no items. Pick a different one.'); return; }

      var bad = unavailable();
      if (bad.length) {
        ctaMsg('Sorry - ' + bad.map(function (l) { return l.label; }).join(', ') +
               (bad.length > 1 ? ' are' : ' is') + ' out of stock right now. Try another box.');
        return;
      }

      /* DISABLE ALL SIX, RELABEL ONLY ONE.
         Every checkout button goes disabled for the duration - that is what stops a
         shopper tapping Add to cart and then Shop Pay and firing two carts. But only
         the button they actually pressed says 'Working…'; the other five keep their
         own labels, because relabelling all six made it look like six things were
         happening at once.

         The original label is captured as innerHTML, not textContent, and restored the
         same way. That matters: the main CTA holds <s> and <span> price nodes, and the
         Google Pay button holds an inline <svg> logo mark. textContent would flatten
         both to a bare string and the price and the mark would never come back.

         `pressed` is the element the delegated handler matched. The indexOf check keeps
         this honest - anything not in the live button list falls back to the main CTA,
         so a stray programmatic addToCart() still relabels something sensible. */
      var btns = ctaButtons();
      var target = (pressed && btns.indexOf(pressed) !== -1) ? pressed : $('[data-ds-cta]', SEC);
      var label = target ? target.innerHTML : null;
      var restore = function () {
        submitting = false;
        btns.forEach(function (b) { b.disabled = false; });
        if (target && label !== null) target.innerHTML = label;
      };
      var fail = function (msg, err) {
        restore();
        if (err) console.error('[lrc-ds] checkout', err, err && err.body);
        ctaMsg(msg);
      };
      submitting = true;
      ctaMsg('');
      btns.forEach(function (b) { b.disabled = true; });
      if (target) target.textContent = 'Working…';

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (!r.ok) return r.text().then(function (t) {
            var e = new Error('cart clear failed: ' + r.status); e.body = t; e.stage = 'clear'; throw e;
          });
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) {
          if (!r.ok) return r.text().then(function (t) {
            var e = new Error('cart add failed: ' + r.status); e.body = t; e.stage = 'add'; throw e;
          });
          /* Only here, after a confirmed 200 from add.js, do we leave the page. */
          window.location.href = checkoutUrl();
        })
        .catch(function (err) {
          fail(err && err.stage === 'clear'
            ? 'Could not reset your cart. Please try again.'
            : 'Something went wrong adding your box. Nothing has been charged - please try again.', err);
        });
    }

    /* THE EXPRESS BUTTONS ARE NOT WALLET INTEGRATIONS. READ THIS BEFORE "FIXING" THEM.
       Shop Pay, PayPal, Apple Pay and Google Pay here are STYLED ENTRY POINTS TO THE
       STANDARD CHECKOUT. Every one of them runs the same addToCart() as the main CTA and
       lands on the same /checkout?discount=<code> URL; the shopper then picks their real
       payment method on Shopify's checkout, where those wallets are offered natively.
       They are a visual advertisement of what is available at checkout, nothing more.

       They are deliberately NOT native wallet SDK buttons. A real wallet button posts
       straight into Shopify's accelerated checkout and never traverses the discount URL,
       which would silently drop the Buy X Get Y that zeroes the gift and the hat - the
       shopper would be charged for items this page promised free. Routing them through
       addToCart() is what makes them safe to ship.

       So: do not "upgrade" these into native wallet buttons, and do not give them their
       own click path. They belong to the same delegated handler and the same six-button
       pending guard as the main CTA.

       ---------- events, all delegated from the section ----------
       ONE path to checkout: the main CTA and the sticky-bar CTA both land on addToCart().
       The What's inside sheet has no checkout button - in the mockup its footer button
       selects the tier and closes, and this build omits it entirely. */
    SEC.addEventListener('click', function (e) {
      var pl = e.target.closest('[data-ds-plan]');
      if (pl) {
        state.plan = pl.getAttribute('data-ds-plan');
        $$('[data-ds-plan]', SEC).forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === pl));
        });
        refreshTierMeta(); rollTierPrices(); update();
        return;
      }
      var ins = e.target.closest('[data-ds-inside]');
      if (ins) { e.stopPropagation(); openInside(ins.getAttribute('data-ds-inside')); return; }
      var gf = e.target.closest('[data-ds-gift]');
      if (gf) { state.gift = gf.getAttribute('data-ds-gift'); refreshTierMeta(); rollTierPrices(); update(); return; }
      var ti = e.target.closest('[data-ds-tier]');
      if (ti) { state.tier = ti.getAttribute('data-ds-tier'); paintActive(); update(); return; }
      if (e.target.closest('[data-ds-sheet-close]')) { closeSheet(); return; }
      var sheet = e.target.closest('[data-ds-sheet]');
      if (sheet && e.target === sheet) { closeSheet(); return; }
      /* One selector, one call, and the matched element is passed through so
         addToCart() knows which button to relabel. */
      var go = e.target.closest('[data-ds-cta],[data-ds-st-cta],[data-ds-x-cta]');
      if (go) { addToCart(go); }
    });
    SEC.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeSheet(); return; }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target.closest('[data-ds-tier]');
      var i = e.target.closest('[data-ds-inside]');
      if (i) { e.preventDefault(); e.stopPropagation(); openInside(i.getAttribute('data-ds-inside')); return; }
      if (t) { e.preventDefault(); state.tier = t.getAttribute('data-ds-tier'); paintActive(); update(); }
    });

    /* ---------- sticky bar ----------
       Revealed once the main CTA has scrolled out of view UPWARD. The
       boundingClientRect.top < 0 test is what makes it upward-only, so the
       bar does not appear while the CTA is still below the fold. */
    (function () {
      var cta = $('[data-ds-cta]', SEC), bar = $('[data-ds-sticky]', SEC);
      if (!cta || !bar || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (en) {
        bar.setAttribute('data-show', String(!en[0].isIntersecting && en[0].boundingClientRect.top < 0));
      }, { threshold: 0 }).observe(cta);
    })();

    /* Truncation guard. A non-paginated Liquid loop over a collection stops at
       50 products, which would silently leave wanted variants unpriced. */
    if (SEC.getAttribute('data-design-mode') === 'true' && CFG.indexScanned >= 50) {
      var host = $('[data-ds-tiers]', SEC);
      if (host) {
        var w = document.createElement('div');
        w.className = 'ds-warn';
        w.textContent = 'Catalog index walked ' + CFG.indexScanned +
          ' products and stopped at the 50-product Liquid limit. Point the catalog setting at a smaller collection or some variants will price at $0.00.';
        host.parentNode.insertBefore(w, host);
      }
    }

    renderTiers(); renderGiftSwitch(); update();
  })();

  /* ---------- compare: pills swap table panels ---------- */
  (function () {
    var host = $('[data-ds-compare]');
    if (!host) return;
    host.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-ds-cmp]');
      if (!pill) return;
      var key = pill.getAttribute('data-ds-cmp');
      $$('[data-ds-cmp]', host).forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === pill));
      });
      $$('[data-ds-cmp-panel]', host).forEach(function (p) {
        p.hidden = p.getAttribute('data-ds-cmp-panel') !== key;
      });
      $$('[data-ds-cmp-foot]', host).forEach(function (p) {
        p.hidden = p.getAttribute('data-ds-cmp-foot') !== key;
      });
    });
  })();

  /* ---------- accordions: opening one closes its siblings ----------
     The markup uses the native exclusive accordion (<details name="...">).
     Safari and Firefox shipped that later than Chrome, so this is a fallback
     for engines without it. Feature-detected, so supporting browsers keep the
     native behaviour and this does nothing. */
  (function () {
    var supportsName = 'name' in document.createElement('details');
    if (supportsName) return;
    ROOT.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || d.tagName !== 'DETAILS' || !d.open) return;
      var name = d.getAttribute('name');
      if (!name) return;
      $$('details[name="' + name + '"]').forEach(function (o) {
        if (o !== d) o.open = false;
      });
    }, true);
  })();

  /* ---------- review summary sheet ----------
     CROSS-SECTION BINDING. The sheet is owned by the reviews section, but the
     hero's review row ([data-ds-reviews]) has to open it. Liquid sections
     cannot see each other, so the wiring happens here: this file is ROOT-scoped
     and ROOT spans every section on the page, so one delegated listener reaches
     both. State is data-show, never data-open (see the note on openInside above).

     REMOVAL FAILURE MODE: if the reviews section is deleted from the template
     the sheet element does not exist, `sheet` is null, and every handler
     returns early. The hero's review row becomes an inert button - no error, no
     console noise, nothing thrown. */
  (function () {
    var sheet = $('[data-ds-review-sheet]');

    function open() { if (sheet) sheet.setAttribute('data-show', 'true'); }
    function close() { if (sheet) sheet.setAttribute('data-show', 'false'); }

    ROOT.addEventListener('click', function (e) {
      if (e.target.closest('[data-ds-reviews]') || e.target.closest('[data-ds-review-open]')) {
        if (!sheet) return;          /* reviews section removed: no-op */
        e.preventDefault();
        open();
        return;
      }
      if (e.target.closest('[data-ds-review-close]')) { close(); return; }
      if (sheet && e.target === sheet) { close(); }
    });
    ROOT.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet && sheet.getAttribute('data-show') === 'true') close();
    });
  })();

  /* Exposed so later phases extend this file rather than adding a
     second script with its own unscoped lookups. */
  window.LRC_DS = { root: ROOT, $: $, $$: $$, byId: byId, reduced: reduced };
})();
